<template>
  <div>
    <h3 class="mb-5">News Banner+Video</h3>
    <div class="h4 mb-5">可新增多個</div>

    <!-- itemList -->
    <PageCollapse v-for="(item, i) in bu.news_bannervideo" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Banner {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Basic section -->
        <div>
          <!-- title -->
          <label class="form-item d-flex pt-3">
            <h4 class="w-180px mt-5">Title</h4>
            <div class="flex-grow-1 mt-2">
              <v-textarea
                v-model="item.title"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- description -->
          <label class="form-item d-flex pt-3">
            <h4 class="w-180px mt-5">Description</h4>
            <div class="flex-grow-1 mt-2">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- 顯示/隱藏 -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <div class="w-180px">
              <h4 class="mb-10px">顯示/隱藏</h4>
            </div>
            <div class="flex-grow-1 flex-basis-0">
              <FormSwitch v-model="item.status"></FormSwitch>
            </div>
          </div>
          <!-- banner position -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <div class="w-180px">
              <h4 class="mr-35px">position</h4>
              <div class="h5 ink-02-medium--text">
                輪播廣告文字方向
              </div>
            </div>
            <div class="flex-grow-1">
              <v-radio-group row v-model="item.position">
                <div
                  v-for="position in ['left', 'right']"
                  :key="position"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="position">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ position }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
          <!-- banner type -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <h4 class="w-180px">Banner Type</h4>
            <div class="flex-grow-1">
              <v-radio-group row v-model="item.type">
                <div
                  v-for="type in ['image', 'video']"
                  :key="type"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="type">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ type }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
          <!-- banner play type(For XPG only) -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <div class="w-180px">
              <h4 class="mr-35px">Banner Display</h4>
              <div class="h5 ink-02-medium--text">
                (Slide: 上方輪播, Fixed: 下方重點)<br />
                限制數量，Fixed最多4個; Slide最多6個
              </div>
            </div>
            <div class="flex-grow-1">
              <v-radio-group row v-model="item.displaytype">
                <div
                  v-for="displaytype in ['slide', 'fixed']"
                  :key="displaytype"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="displaytype">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ displaytype }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
        </div>

        <!-- banner type = Image -->
        <div v-if="item.type == 'image'">
          <!-- url -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">URL</h4>
            <div class="flex-grow-1 mt-3">
              <v-text-field
                v-model="item.url"
                prepend-inner-icon="mdi-link"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
        </div>

        <!-- banner type = Video -->
        <div v-if="item.type == 'video'">
          <!-- upload type -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <h4 class="w-180px mr-35px">UploadType</h4>
            <div class="flex-grow-1">
              <v-radio-group v-model="item.upload_type" row>
                <div
                  v-for="uploadType in [
                    {
                      label: '自電腦上傳影片',
                      value: 'file',
                    },
                    {
                      label: '來自Youtube/Youku連結',
                      value: 'link',
                    },
                  ]"
                  :key="uploadType.value"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="uploadType.value">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ uploadType.label }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
        </div>

        <!-- banner type = Video, upload type = 自電腦上傳影片 -->
        <div v-if="item.type == 'video' && item.upload_type == 'file'">
          <!-- 影片上傳 -->
          <div class="form-item d-flex px-5 pt-5 pb-5">
            <div class="w-200px">
              <h4 class="mb-10px">影片</h4>
              <div class="h5 ink-02-medium--text">
                影片支援格式：.mp4, .mov, .avi <br />
                檔案大小限制：&lt; 10 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <FileUploader
                v-model="item.url"
                dir="bu_videos"></FileUploader>
            </div>
          </div>
        </div>

        <!-- banner type = Video, upload type = 來自Youtube/Youku連結 -->
        <div v-if="item.type == 'video' && item.upload_type == 'link'">
          <!-- Youtube -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">影片連結</h4>
            <div class="flex-grow-1 my-3">
              <v-text-field
                v-model="item.url"
                prepend-inner-icon="mdi-link"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Youku -->
          <!--<label class="px-5 d-flex">-->
            <!--<h4 class="w-180px my-5 mr-6">Youku</h4>-->
            <!--<div class="flex-grow-1 my-3">-->
              <!--<div class="form-input-group">-->
                <!--<div class="prepend-icon" style="top: 45%;">-->
                  <!--<v-icon>link</v-icon>-->
                <!--</div>-->
                <!--<input type="text" class="pl-42px" v-model="item.youkuUrl" />-->
              <!--</div>-->
            <!--</div>-->
          <!--</label>-->
        </div>
        <!-- img upload -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Visual</h4>
            <div class="h5 ink-02-medium--text">
              Slide 尺寸：<br/>
              ADATA: 1920 px X 648 px <br />
              XPG: 1920 px X 640 px <br/>
              Fixde 尺寸: <br/>
              ADATA: 無此功能 <br />
              XPG: 1640 px X 720 px <br/>
              Business: 634 px X 500 px <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.visual"
              dir="bu_videos"></ImgUploader>
          </div>
        </div>
        <!-- img upload -->
        <div class="d-flex px-5 pt-5 mb-8" v-if="item.displaytype == 'slide'">
          <div class="w-180px">
            <h4 class="mb-10px">Visual for Mobile</h4>
            <div class="h5 ink-02-medium--text">
              ADAT | XPG 廣告輪播用 <br />
              建議尺寸：480 px X 650 px <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.mobile_visual"
              dir="bu_videos"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add item -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加New Banner+Video</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
    FileUploader,
    FormSwitch,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        description: '',
        type: 'image',
        url: '',
        visual: '',
        mobile_visual: '',
        upload_type: 'file',
        video: '',
        position: 'left',
        displaytype: 'slide',
        status: true,
      };
      this.bu.news_bannervideo.push(template);
    },
    deleteItem(item) {
      const index = this.bu.news_bannervideo.map((option) => option.id).indexOf(item.id);
      this.bu.news_bannervideo.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.bu.news_bannervideo.length - 1) {
        this.bu.news_bannervideo.splice(i, 1);
        this.bu.news_bannervideo.unshift(item);
        return;
      }
      // item become next index
      this.bu.news_bannervideo.splice(i, 1);
      this.bu.news_bannervideo.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.bu.news_bannervideo.splice(i, 1);
        this.bu.news_bannervideo.push(item);
        return;
      }
      // item become previous index
      this.bu.news_bannervideo.splice(i, 1);
      this.bu.news_bannervideo.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
